export class FinishEcvModel {
  checked: boolean;
  domainDictId: number;
  cvTargetDictId: number;
  comment: string;
  userId: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/finish-ecv/finish-ecv.model.ts